import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_4_13_2
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-visit-exemptions-exemption-4-13-2',
    templateUrl: './exemption_4_13_2.component.html',
    styleUrls: ['./exemption_4_13_2.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_4_13_2Component extends ExemptionBaseComponent {

  dangerousGoods?: DangerInformation
  portVisitUtils = PortvisitUtils;

  @Input() exemption: Exemption_4_13_2;

  OTHER = 'Other';
  YES = 'Yes';

  storageTypes: string[] = ['',
    this.YES,
    'No, direct removal with truck'
  ];

  transshipmentTypes: string[] = ['',
    'Mobile crane',
    this.OTHER
  ];

  resetTransshipmentTypeOther() {
    this.exemption.transshipmentTypeOther = '';
  }

  resetTemporaryStorageDates() {
    this.exemption.from = '';
    this.exemption.to = '';
  }
}

